import React from 'react';

interface TableCellProps {
    children: React.ReactNode;
    type: 'head' | 'body' | 'foot';
    additionalClasses?: string;
    draggable?: boolean;
    colSpan?: number;
}

const TableCell: React.FC<TableCellProps> = (props) => {
    const { children, type, draggable, colSpan, additionalClasses } = props;

    if (type === 'head' || type === 'foot') {
        return (
            <th draggable={draggable} colSpan={colSpan} className={additionalClasses}>
                {children}
            </th>
        );
    }

    if (type === 'body') {
        return (
            <td draggable={draggable} colSpan={colSpan} className={additionalClasses}>
                {children}
            </td>
        );
    }
};

export default TableCell;
